import React from 'react';
import classNames from 'classnames';
import ImageGallery from 'react-image-gallery';

import { Section, Layout, SEO, StoreBadge } from '..';

import '../../../node_modules/react-image-gallery/styles/css/image-gallery.css';

import style from './GameUnsolvedCasePage.module.less';

import hero from './assets/heroUnsolvedCase.jpg';
import walkietalkie from './assets/walkietalkie.png';
import logo from './assets/unsolvedCaseLogo.png';
import box from './assets/box.png';
import bars from './assets/bars.png';
import adventure from './assets/ck.png';
import watches from './assets/watches.png';
import arcade from './assets/arcade.png';
import warehouse from './assets/warehouse.png';
import collaborative from './assets/collaborative.png';
import oldCase from './assets/oldCase.png';
import teambuilding from './assets/teambuilding.jpg';

// screenshots
import screenshot1 from './assets/Screenshot1.jpg';
import screenshot2 from './assets/Screenshot2.jpg';
import screenshot3 from './assets/Screenshot3.jpg';
import screenshot4 from './assets/Screenshot4.jpg';
import screenshot5 from './assets/Screenshot5.jpg';
import screenshot6 from './assets/Screenshot6.jpg';
import screenshot7 from './assets/Screenshot7.jpg';
import screenshot8 from './assets/Screenshot8.jpg';

const screenshots = [
  { original: screenshot1 },
  { original: screenshot2 },
  { original: screenshot3 },
  { original: screenshot4 },
  { original: screenshot5 },
  { original: screenshot6 },
  { original: screenshot7 },
  { original: screenshot8 }
];

export const GameUnsolvedCasePage = () => (
  <Layout transparentTop={true}>
    <SEO
      title="Unsolved Case"
      description="Unsolved Case is the free prequel to the popular cooperative point-and-click puzzle game 'Cryptic Killer' series."
    />

    <Section className={style.hero} alternate={true} straightTop={true} style={{ backgroundImage: `url(${hero})` }}>
      <div className={style.wrapper}>
        <div className={style.game}>
          <img src={logo} alt="Unsolved Case" className={style.gameLogo} />
        </div>
      </div>
    </Section>

    <Section className={style.steam}>
      <h1>Available now!</h1>
      <div className={style.row}>
        <div className={style.content}>
          <StoreBadge
            type="Steam Download"
            title="Unsolved Case"
            link="https://store.steampowered.com/app/2084050/Unsolved_Case/"
          />
          <StoreBadge
            type="Google Play Download"
            title="Unsolved Case"
            link="https://play.google.com/store/apps/details?id=com.elevenpuzzles.unsolvedcase"
          />
          <StoreBadge
            type="App Store Download"
            title="Unsolved Case"
            link="https://apps.apple.com/us/app/unsolved-case/id1639547822"
          />
        </div>
      </div>
    </Section>

    <Section className={style.gameStory} alternate={true}>
      <div className={style.content}>
        <h1>Co-op puzzle adventure</h1>
        <div className={classNames(style.row, style.evenColumns)}>
          <div className={style.text}>
            <p>Unsolved Case is the free prequel to the popular cooperative point-and-click puzzle game 'Cryptic Killer' series.</p>
            <p>Dip your toes in and go back to where it all began as you team up in two as detective duo Old Dog and Ally, up against the Cryptic Killer. For the first time in the series, you'll encounter a labyrinth of puzzles and challenges laid by one of the most devious minds in the world. Solve puzzles, crack codes, and find a way out.</p>
            <p>Have you got what it takes to crack the Unsolved Case of the Cryptic Killer?</p>
          </div>
          <div className={style.image}>
            <img src={walkietalkie} alt="Adventure" />
          </div>
        </div>
      </div>
    </Section>

    <Section className={style.gameStory}>
      <div className={style.content}>
        <h1>The prequel</h1>
        <div className={classNames(style.row, style.alternate, style.evenColumns)}>
          <div className={style.text}>
            <h2>Cold case</h2>
            <p>Years ago the twisted Cryptic Killer was put away behind bars at the infamous Anagram Asylum. But today, he's back, and he's taunting the detectives. Did they catch the wrong guy, or are they looking at a copycat killer?</p>
          </div>
          <div className={style.image}>
            <img src={oldCase} alt="Adventure" />
          </div>
        </div>
        <div className={classNames(style.row, style.evenColumns)}>
          <div className={style.text}>
            <h2>Mysterious box</h2>
            <p>A new lead arrives in the form of a mysterious locked box. Delivered direct to their addresses, detectives Ally and Old Dog are once again sent on a chase that'll challenge them unlike any case before. Explore new locations, crack codes, and unravel the mystery. In this prequel, you're invited to step into the detective's shoes and return to where it all began.</p>
          </div>
          <div className={style.image}>
            <img src={box} alt="Box" />
          </div>
        </div>
      </div>
    </Section>

    <Section className={style.gameStory} alternate={true}>
      <div className={style.content}>
        <h1>The only way to escape is to work together</h1>
        <div className={classNames(style.row, style.evenColumns)}>
          <div className={style.text}>
            <p>Two minds are better than one, and the only way you'll be able to crack the Cryptic Killer's codes is by working together. Through separate screens, you and a friend will be given half of a puzzle at each location. Communicate, collaborate, and work together to push your puzzle-solving skills to the limit.</p>
            <p>📦 Crack the codes to get into the locked box</p>
            <p>🧠 Combine your knowledge to solve challenging puzzles</p>
            <p>🧩 Fax each other information across two locations</p>
            <p>🎲 Rewire equipment, hack the CCTV, and work together to escape</p>
            <p>✏️ Get creative - some puzzles require you to draw on the screen</p>
            <p>❄️ Hurry, or you'll lose more than just the case!</p>
          </div>
          <div className={style.image}>
            <img src={teambuilding} alt="Adventure" />
          </div>
        </div>
      </div>
    </Section>

    <Section className={style.featuresList} alternate={false}>
      <div className={style.content}>
        <h1>Features</h1>
        <div className={classNames(style.row, style.evenColumns, style.alternate)}>
          <div className={style.text}>
            <h2>Free game</h2>
            <p>Dip your toes in and play detective for the day in this prequel case for detectives Ally and Old Dog, before you try the full series.</p>
          </div>
          <div className={style.image}>
            <img src={arcade} alt="Arcade" />
          </div>
        </div>
        <div className={classNames(style.row, style.evenColumns)}>
          <div className={style.text}>
            <h2>30-60 Minutes to Solve</h2>
            <p>The prequel takes place over one bitesize chunk of fast-paced, puzzle-solving gameplay.</p>
          </div>
          <div className={style.image}>
            <img src={watches} alt="Watches" />
          </div>
        </div>
        <div className={classNames(style.row, style.evenColumns, style.alternate)}>
          <div className={style.text}>
            <h2>Two Player Co-Op</h2>
            <p>In Unsolved Case, the detectives are separated. You’ll see different items and clues than your partner and will be tested on your communication!</p>
          </div>
          <div className={style.image}>
            <img src={adventure} alt="Two player coop" />
          </div>
        </div>
        <div className={classNames(style.row, style.evenColumns)}>
          <div className={style.text}>
            <h2>Challenging Collaborative Puzzles</h2>
            <p>Two brains are better than one when it comes to cracking the Cryptic Killer's codes.</p>
          </div>
          <div className={style.image}>
            <img src={collaborative} alt="collaborative" />
          </div>
        </div>
        <div className={classNames(style.row, style.evenColumns, style.alternate)}>
          <div className={style.text}>
            <h2>Explore Illustrated Worlds</h2>
            <p>Unsolved Case's hand illustrated environments are inspired by noir novels.</p>
          </div>
          <div className={style.image}>
            <img src={warehouse} alt="Warehouse " />
          </div>
        </div>
        <div className={classNames(style.row, style.evenColumns)}>
          <div className={style.text}>
            <h2>Draw on… Everything!</h2>
            <p>You can't solve a case without taking notes. At any time in the game, you can whip out a notebook and pen to make notes and scribble on your environment.</p>
          </div>
          <div className={style.image}>
            <img src={bars} alt="Draw on anything" />
          </div>
        </div>
      </div>
    </Section>

    <Section className={style.screenshots} alternate={true}>
      <h1>Game screenshots</h1>
      <ImageGallery
        additionalClass={style.gallery}
        items={screenshots}
        showNav={true}
        showThumbnails={false}
        showFullscreenButton={false}
        showPlayButton={false}
        showBullets={false}
      />
    </Section>

    <Section className={style.steam}>
      <h1>Available now!</h1>
      <div className={style.row}>
        <div className={style.content}>
          <StoreBadge
            type="Steam Download"
            title="Unsolved Case"
            link="https://store.steampowered.com/app/2084050/Unsolved_Case/"
          />
          <StoreBadge
            type="Google Play Download"
            title="Unsolved Case"
            link="https://play.google.com/store/apps/details?id=com.elevenpuzzles.unsolvedcase"
          />
          <StoreBadge
            type="App Store Download"
            title="Unsolved Case"
            link="https://apps.apple.com/us/app/unsolved-case/id1639547822"
          />
        </div>
      </div>
    </Section>
  </Layout>
);

